import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";
import { CurrentOverrides } from "../override/current_overrides";
import { CreateOverride } from "../override/create_override";

export function OverrideDialog({ open, setOpen, siteData }) {
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="override-dialog-title"
      aria-describedby="override-dialog-description"
      fullWidth
      maxWidth={"lg"}
    >
      <DialogTitle id="shell-dialog-title">{"Manual Override"}</DialogTitle>
      <DialogContent>
        <CurrentOverrides siteData={siteData} />
        <CreateOverride siteData={siteData} />
      </DialogContent>
    </Dialog>
  );
}
